import { PaginationOptions } from "./PaginationOptions.interface";

export enum FilterCampaignStatus {
    Upcoming = "Upcoming",
    Scheduled = "Scheduled", 
    Processed = "Processed",
    Cancelled = "Cancelled"
}

export interface CampaignFilterOptions extends PaginationOptions {
    status?: FilterCampaignStatus;
}